var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showPlansPopup)?_c('subscribe',{attrs:{"subscribePayload":_vm.subscribepayload,"closePopup":function () { return _vm.toggleSubscribePopup(false); }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }